import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { IoArrowBack } from 'react-icons/io5';

const StyledBackButton = styled(Link)`
  position: absolute;
  top: -1rem;
  left: 2rem;
  z-index: 100;
  color: white;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: none;
  border: none;
  transition: all 0.2s ease;
  font-size: 2.5rem;

  &:hover {
    transform: translateX(-4px);
    opacity: 0.8;
  }
  
  @media (max-width: 768px) {
    top: -1rem;
    left: 0.5rem;
    font-size: 1.75rem;
  }
`;

function BackButton({ to, children }) {
  return (
    <StyledBackButton to={to}>
      <IoArrowBack />
    </StyledBackButton>
  );
}

export default BackButton;

